import {
  resetAuthLoopGuard,
  shouldBlockAutoSignin,
} from '@services/authLoopGuard'
import { loadUserFromStorage, signinRedirect } from '@services/oauthService'
import appStore from '@stores/appStore'
import ui from '@stores/dashboard'
import { observer } from 'mobx-react'
import { useCallback, useEffect, useState } from 'react'

import MaintenanceScreen from '../errors/MaintenanceScreen'

import AuthErrorScreen from './AuthErrorScreen'

const AuthWrapper = ({ children, onReady }) => {
  const [ready, setReady] = useState(false)
  const [signinBlocked, setSigninBlocked] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      ui.didmount('a.Tab', '.Tabs-Inner')
    }, 1000)

    window.addEventListener('beforeunload', cleanUp)
    if (!appStore.authenticated) {
      bootstrap().then(() => {
        setReady(true)
        onReady && onReady()
      })
    }
    return () => {
      cleanUp()
    }
  }, [])

  const bootstrap = async () => {
    const user = await loadUserFromStorage()
    if (user) {
      // Signed in successfully — clear any loop-guard state
      resetAuthLoopGuard()
      await appStore.init()
    } else if (shouldBlockAutoSignin()) {
      // The signin callback keeps failing (wrong device clock, blocked
      // storage, ...). Stop redirecting and show the real error instead of
      // looping between "/" and the identity server forever.
      setSigninBlocked(true)
    } else if (window.location.pathname !== '/signin-oidc') {
      await signinRedirect({ redirectUri: window.location.pathname })
    }
    return true
  }

  const cleanUp = useCallback(() => {
    ui.unmount()
    window.removeEventListener('beforeunload', cleanUp)
  }, [])

  if (signinBlocked) {
    return <AuthErrorScreen />
  }

  // Maintenance Mode: the tenant is under maintenance and this user is not exempt (the server
  // already applied the host / tenant-admin exemptions). Shown instead of the application so a
  // session that predates the switch cannot keep navigating it.
  if (appStore.authenticated && ready && appStore.isUnderMaintenance) {
    return (
      <MaintenanceScreen
        title={appStore.maintenance.title}
        message={appStore.maintenance.message}
      />
    )
  }

  return appStore.authenticated && ready ? <>{children}</> : null
}

export default observer(AuthWrapper)
